import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { TransitionCheckState } from '@angular/material/checkbox';
import { AuthService } from 'app/core/auth/auth.service';
import { UserRole } from 'app/core/roles/roles.model';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation | any;
    routes: any;
    user: User;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private authService: AuthService,
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
    ) {
        iconRegistry.addSvgIcon(
            'fullscreen',
            sanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/fullscreen.svg',
            ),
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // this._navigationService.navigation$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((navigation: Navigation) => {
        //         this.navigation = navigation;
        //     });
        // this._userService.user$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((user: User) => {
        //         this.user = user;
        //     });
        // this._fuseMediaWatcherService.onMediaChange$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe(({ matchingAliases }) => {
        //         this.isScreenSmall = !matchingAliases.includes('md');
        //     });
        this.routes = {
            default: [
                {
                    id: 'dashboards',
                    title: 'Dashboards',
                    subtitle: '',
                    type: 'group',
                    children: [
                        // {
                        //     id: 'finance',
                        //     title: 'Cashforo',
                        //     type: 'basic',
                        //     icon: 'heroicons_outline:currency-euro',
                        //     link: '/dashboards/finance',
                        // },
                    ],
                },

                {
                    id: 'tables',
                    title: 'Cashforo Tables',
                    subtitle: '',
                    type: 'group',
                    children: [
                        // {
                        //     id: 'cashforo_table',
                        //     title: 'Cashforo Table',
                        //     type: 'basic',
                        //     icon: 'heroicons_outline:currency-euro',
                        //     link: '/tables/cashforo-table',
                        // },
                        {
                            id: 'cashforo_table-v2',
                            title: 'Table',
                            type: 'basic',
                            icon: 'heroicons_outline:new-table',
                            link: '/tables/cashforo-table-v2',
                            roles: [],
                        },
                        {
                            id: 'withdraw ',
                            title: 'Withdraw',
                            type: 'basic',
                            icon: 'heroicons_outline:new-wallet',
                            link: '/tables/cashforo-withdraw-v2',
                            roles: [
                                UserRole.Admin,
                                UserRole.SuperUser,
                                UserRole.MerchantAdmin,
                                UserRole.Support,
                                UserRole.Viewer,
                            ],
                        },
                        // {
                        //     id: 'withdraw-manual',
                        //     title: 'Cashforo manual withdraw',
                        //     type: 'basic',
                        //     icon: 'heroicons_outline:currency-euro',
                        //     link: '/tables/cashforo-withdraw/manual',
                        //     roles: [],
                        // },
                        {
                            id: 'user-table',
                            title: 'User Table',
                            type: 'basic',
                            icon: 'heroicons_outline:new-user',
                            link: '/tables/user-table',
                            roles: [UserRole.SuperUser, UserRole.MerchantAdmin],
                        },
                        {
                            id: 'roles-table',
                            title: 'Roles',
                            type: 'basic',
                            icon: 'heroicons_outline:new-chart',
                            link: '/tables/roles-table',
                            roles: [UserRole.SuperUser],
                        },
                        {
                            id: 'merchant-table ',
                            title: 'Merchant Table',
                            type: 'basic',
                            icon: 'heroicons_outline:new-merch-table',
                            link: '/tables/merchant-table',
                            roles: [UserRole.SuperUser],
                        },
                        {
                            id: 'paymentsystem-configuration',
                            title: 'Payment system configuration',
                            type: 'basic',
                            icon: 'heroicons_outline:new-payment',
                            link: '/tables/paymentsystem-configurations',
                            roles: [UserRole.SuperUser],
                        },
                        {
                            id: 'payment-system-tags',
                            title: 'Payment system tags',
                            type: 'basic',
                            icon: 'heroicons_outline:new-pay-systems',
                            link: '/tables/payment-system-tags',
                            roles: [UserRole.SuperUser],
                        },
                        {
                            id: 'payment-system-balances',
                            title: 'Payment system balances',
                            type: 'basic',
                            icon: 'heroicons_outline:new-pay-balance',
                            link: '/tables/payment-system-balances',
                            roles: [UserRole.SuperUser, UserRole.Support],
                        },
                        {
                            id: 'withdraw-limits',
                            title: 'Withdraw limits',
                            type: 'basic',
                            icon: 'heroicons_outline:new-with-limits',
                            link: '/tables/withdraw-limits',
                            roles: [UserRole.SuperUser, UserRole.MerchantAdmin],
                        },
                        {
                            id: 'verification',
                            title: 'Verification',
                            type: 'collapsable',
                            icon: 'heroicons_outline:new-verification',
                            roles: [UserRole.SuperUser, UserRole.Support],
                            children: [
                                {
                                    id: 'Payment System',
                                    title: 'Payment System',
                                    type: 'basic',
                                    roles: [
                                        UserRole.SuperUser,
                                        UserRole.Support,
                                    ],
                                    link: '/tables/verification/payment-system-verification',
                                },
                                {
                                    id: 'Identity',
                                    title: 'Identity',
                                    type: 'basic',
                                    roles: [
                                        UserRole.SuperUser,
                                        UserRole.Support,
                                    ],
                                    link: '/tables/verification/identity-verification',
                                },
                                {
                                    id: 'Custom Verification',
                                    title: 'Custom Verification',
                                    type: 'basic',
                                    roles: [
                                        UserRole.SuperUser,
                                        UserRole.Support,
                                    ],
                                    link: '/tables/verification/custom-verification',
                                },
                            ],
                        },
                        {
                            id: 'metabase',
                            title: 'Metabase',
                            type: 'basic',
                            icon: 'heroicons_outline:currency-euro',
                            link: 'https://cashforo.com/metabase/',
                            externalLink: true,
                            roles: [UserRole.SuperUser, UserRole.MerchantAdmin],
                        },
                    ],
                },
            ],
        };

        const filteredChildRoutes = new Set();
        this.authService.getJwtCookie().then((result) => {
            this.routes.default[1]?.children.filter((child: any) => {
                result.forEach((role) => {
                    if (
                        child?.roles?.includes(role) ||
                        child?.roles?.length === 0
                    ) {
                        filteredChildRoutes.add(child);
                    }
                });
            });
            this.routes.default[1].children = Array.from(filteredChildRoutes);
            this.navigation = this.routes;
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name,
            );
        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
